var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: "#1.0",
    d: "M12.587 18.878c.766-.61 1.531-1.298 2.244-2.05C16.82 14.728 18 12.565 18 10.5c0-3.314-2.686-6-6-6s-6 2.686-6 6c0 2.065 1.18 4.227 3.17 6.328.712.752 1.477 1.44 2.243 2.05.208.166.405.317.587.451.182-.134.379-.285.587-.45zM12 3c4.142 0 7.5 3.358 7.5 7.5 0 2.529-1.352 5.007-3.58 7.36-.765.806-1.581 1.541-2.398 2.192-.286.228-.553.43-.793.602-.146.106-.253.18-.313.22-.252.168-.58.168-.832 0-.06-.04-.167-.114-.313-.22-.24-.173-.507-.374-.793-.602-.817-.65-1.633-1.386-2.397-2.192C5.85 15.507 4.5 13.029 4.5 10.5 4.5 6.358 7.858 3 12 3zm0 4.5c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zM12 9c.828 0 1.5.672 1.5 1.5S12.828 12 12 12s-1.5-.672-1.5-1.5S11.172 9 12 9z",
    transform: "translate(-136 -274) translate(40 274) translate(96)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5cbe7ce6.svg";
export { ForwardRef as ReactComponent };